/**
 * @file modifierKey.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-10
 * @modified 2026-09-10
 * @description Which modifier key this machine actually has.
 *
 *              The shortcut listens for either — metaKey OR ctrlKey — so it
 *              works everywhere. The BADGE cannot do both: "⌘K" on a Windows
 *              laptop names a key that is not on the keyboard, and most of the
 *              office is on Windows.
 *
 *              navigator.platform is deprecated but is still the only thing
 *              every browser agrees on; userAgentData is Chromium-only. Both
 *              are consulted and the answer defaults to Ctrl, which is right
 *              for anything that is not a Mac.
 */

function isApple() {
  if (typeof navigator === 'undefined') return false;
  const hinted = navigator.userAgentData?.platform;
  if (hinted) return /mac/i.test(hinted);
  return /mac|iphone|ipad|ipod/i.test(navigator.platform || navigator.userAgent || '');
}

/** '⌘' on a Mac, 'Ctrl' everywhere else. */
export const MOD_KEY_LABEL = isApple() ? '\u2318' : 'Ctrl';

/** The label for a shortcut, e.g. '⌘K' or 'Ctrl+K'. */
export function shortcutLabel(key) {
  return isApple() ? `${MOD_KEY_LABEL}${key}` : `${MOD_KEY_LABEL}+${key}`;
}

export default shortcutLabel;
